import { Link, useMatch, useResolvedPath } from "react-router-dom";
import type { LinkProps } from "react-router-dom";

export default function HeaderLink({ children, to, ...props }: LinkProps) {
  let resolved = useResolvedPath(to);
  let match = useMatch({ path: resolved.pathname, end: true });

  return (
    <div
      className={`flex flex-col justify-between items-center p-2 ${
        match ? "border-b border-toyota" : ""
      }`}
    >
      <Link
        className={match ? "border-b border-toyota" : ""}
        to={to}
        {...props}
      >
        {children}
      </Link>
      {match && ""}
    </div>
  );
}
